import React, { useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { new_passes_list, passes_list } from "../../../../../Studio-Services/Studio_Services";
import { PassList } from "./PassList";
import { AddPassForm } from "./AddPassForm";

export const Addnewpass = () => {
  const [loder, setLoder] = useState(true);
  const [timepass, setTimepass] = useState([]);
  const [recurrigpass, setRecurrigpass] = useState([]);
  const [punchpass, setPunchpass] = useState();
  const [recurringPunchPass, setRecurringPunchPass] = useState([]);


  const [inActiveTimePass, setInActiveTimePass] = useState([]);
  const [inActiveRecurringPass, setInActiveRecurringPass] = useState([]);
  const [inActivePunchPass, setInActivePunchPass] = useState();
  const [inActiveRecurringPunchPass, setInActiveRecurringPunchPass] = useState([]);



  const passListHandler = async () => {
    setLoder(true);
    const passPre = { "page_no": "1" }
    const resp = await new_passes_list(passPre);
    if (resp) {
      setLoder(false);
      const passList = resp.data.data;
      let timep = [];
      let recuring = [];
      let punch = [];
      let RecurringPunch = [];


      let InActiveTimeFrame = [];
      let InActiveRecurring = [];
      let InActivePunch = [];
      let InActiveRecurringPunch = [];


      if (passList) {
        const logo = localStorage.getItem("logo");
        passList.forEach((value) => {
          if (value.pass_type === "Time Frame") {
            if (value.pass_status === "Active") {
              timep.push({
                memberShipImg: logo ? logo : "https://staging.warriorsms.com/superadmin/uploads/business/1664736345WarriorMan_icon2_CMYK.png",
                validText: `Valid For ${value.pass_validity} Days`,
                cardTitle: value.pass_name,
                price: `$ ${value.amount}`,
                tax: "Plus Tax",
                value: value
              })
            } else {
              InActiveTimeFrame.push({
                memberShipImg: logo ? logo : "https://staging.warriorsms.com/superadmin/uploads/business/1664736345WarriorMan_icon2_CMYK.png",
                validText: `Valid For ${value.pass_validity} Days`,
                cardTitle: value.pass_name,
                price: `$ ${value.amount}`,
                tax: "Plus Tax",
                value: value
              })
            }
          } else if (value.pass_type === "Recurring Membership") {
            if (value.pass_status === "Active") {
              recuring.push({
                memberShipImg: logo ? logo : "https://staging.warriorsms.com/superadmin/uploads/business/1664736345WarriorMan_icon2_CMYK.png",
                validText: `Valid For ${value.pass_days} Days`,
                cardTitle: value.pass_name,
                price: `$ ${value.amount}`,
                tax: "Plus Tax",
                value: value
              })
            } else {
              InActiveRecurring.push({
                memberShipImg: logo ? logo : "https://staging.warriorsms.com/superadmin/uploads/business/1664736345WarriorMan_icon2_CMYK.png",
                validText: `Valid For ${value.pass_days} Days`,
                cardTitle: value.pass_name,
                price: `$ ${value.amount}`,
                tax: "Plus Tax",
                value: value
              })
            }
          } else if (value.pass_type === "Punch Card") {
            if (value.is_recurring_billing === 'yes') {
              if (value.pass_status === "Active") {
                RecurringPunch.push({
                  memberShipImg: logo ? logo : "https://staging.warriorsms.com/superadmin/uploads/business/1664736345WarriorMan_icon2_CMYK.png",
                  validText: `Valid For ${value.pass_days} Classes`,
                  cardTitle: value.pass_name,
                  price: `$ ${value.amount}`,
                  tax: "Plus Tax",
                  value: value
                })
              } else {
                InActiveRecurringPunch.push({
                  memberShipImg: logo ? logo : "https://staging.warriorsms.com/superadmin/uploads/business/1664736345WarriorMan_icon2_CMYK.png",
                  validText: `Valid For ${value.pass_days} Classes`,
                  cardTitle: value.pass_name,
                  price: `$ ${value.amount}`,
                  tax: "Plus Tax",
                  value: value
                })
              }
            } else {

              if (value.pass_status === "Active") {
                punch.push({
                  memberShipImg: logo ? logo : "https://staging.warriorsms.com/superadmin/uploads/business/1664736345WarriorMan_icon2_CMYK.png",
                  validText: `Valid For ${value.pass_days} Classes`,
                  cardTitle: value.pass_name,
                  price: `$ ${value.amount}`,
                  tax: "Plus Tax",
                  value: value
                })
              } else {
                InActivePunch.push({
                  memberShipImg: logo ? logo : "https://staging.warriorsms.com/superadmin/uploads/business/1664736345WarriorMan_icon2_CMYK.png",
                  validText: `Valid For ${value.pass_days} Classes`,
                  cardTitle: value.pass_name,
                  price: `$ ${value.amount}`,
                  tax: "Plus Tax",
                  value: value
                })
              }
            }
          }
        });
        setTimepass(timep);
        setRecurrigpass(recuring);
        setPunchpass(punch);
        setRecurringPunchPass(RecurringPunch);

        setInActiveTimePass(InActiveTimeFrame);
        setInActiveRecurringPass(InActiveRecurring);
        setInActivePunchPass(InActivePunch);
        setInActiveRecurringPunchPass(InActiveRecurringPunch);
      }
    }
    setLoder(false);
  }

  useEffect(() => {
    passListHandler();
  }, []);


  return (
    <>
      {loder && <div className='MainLoader'><Spinner animation="border" role="status" className='Loader'></Spinner></div>}
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>
            <Sidebar />
            <Col className="p-0 RightCol">
              <HeaderDashboard />
              <div className="RightSide">
                <section className="addClient innerContent">

                  <Container className="pt-5">
                    <h4>List of Your Passes</h4>
                    <p className="m-2 mb-4">
                      Every class or workshop requires a pass to reserve a space.
                      Set up your list of passes and as you put a new class or
                      workshop on the calendar you can pick which passes will be
                      available for the customer to use for signing up.
                    </p>
                    <div className='AddClientForm AddClientContent'>
                      <div className="PassList mb-4">
                        <h5 className="mt-3" style={{ fontWeight: 'bolder' }}> <u>Active Passes </u></h5>
                        <div className="CardCarousel mt-4 pl-3 pr-3">
                          <p className="mb-0">Recurring Membership</p>
                          {recurrigpass && recurrigpass.length > 0 ?
                            <PassList pass={recurrigpass} />
                            :
                            <div style={{ display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                              <strong>No records found!</strong>
                            </div>
                          }
                        </div>

                        <div className="TimeCard mt-4 pl-3 pr-3">
                          <p className="mb-0">Time Frame</p>
                          {timepass && timepass.length > 0 ?
                            <PassList pass={timepass} />
                            :
                            <div style={{ display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                              <strong>No records found!</strong>
                            </div>
                          }
                        </div>
                        <div className="PunchCard mt-4 pl-3 pr-3">
                          <p className="mb-0">Punch Card</p>
                          {punchpass && punchpass.length > 0 ?
                            <PassList pass={punchpass} />
                            :
                            <div style={{ display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                              <strong>No records found!</strong>
                            </div>
                          }
                        </div>
                        <div className="PunchCard mt-4 pl-3 pr-3">
                          <p className="mb-0">Recurring Punch Card</p>
                          {recurringPunchPass && recurringPunchPass.length > 0 ?
                            <PassList pass={recurringPunchPass} />
                            :
                            <div style={{ display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                              <strong>No records found!</strong>
                            </div>
                          }
                        </div>
                      </div>
                      <hr />

                      <div className="PassList mt-4 mb-4">
                        <h5 className="mt-3" style={{ fontWeight: 'bolder' }}> <u>Inactive Passes</u></h5>
                        <div class="accordion mt-3 pl-3 pr-3" id="accordionExample">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                Recurring Membership
                              </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                              <div class="accordion-body">
                                {inActiveRecurringPass && inActiveRecurringPass.length > 0 ?
                                  <div className="CardCarousel">
                                    <PassList pass={inActiveRecurringPass} />
                                  </div>
                                  :
                                  <div style={{ display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                                    <strong>No records found!</strong>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTwo">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Time Frame
                              </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                              <div class="accordion-body">
                                {inActiveTimePass && inActiveTimePass.length > 0 ?
                                  <div className="TimeCard">
                                    <PassList pass={inActiveTimePass} />
                                  </div>
                                  :
                                  <div style={{ display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                                    <strong>No records found!</strong>
                                  </div>
                                }

                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="headingThree">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Punch Card
                              </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                              <div class="accordion-body">
                                {inActivePunchPass && inActivePunchPass.length > 0 ?
                                  <div className="PunchCard">
                                    <PassList pass={inActivePunchPass} />
                                  </div>
                                  :
                                  <div style={{ display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                                    <strong>No records found!</strong>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="headingThree">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                Recurring Punch Card
                              </button>
                            </h2>
                            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                              <div class="accordion-body">
                                {inActiveRecurringPunchPass && inActiveRecurringPunchPass.length > 0 ?
                                  <div className="PunchCard">
                                    <PassList pass={inActiveRecurringPunchPass} />
                                  </div>
                                  :
                                  <div style={{ display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                                    <strong>No records found!</strong>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <AddPassForm passList={passListHandler} />
                    </div>
                  </Container>
                </section>
                <Footer />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
